import React from "react";

const WarrantyInfo = () => {
  return (
    <div className=" max-w-[1200px] max-xl:max-w-full mx-auto max-xl:mx-6 py-4 md:py-6 lg:py-16">
      <h2 className="text-[#121212] text-[18px] lg:text-[22px] font-[poppins] font-bold  mb-3 md:mb-4 lg:mb-5">
        Warranty Policy
      </h2>
      <p className="text-[#4A4C56] text-[13px] font-medium text-justify  mb-3 md:mb-4 lg:mb-5">
        Sicunet Inc. warrants its products to be free from defects in material
        and workmanship subject to the terms set forth herein (“Warranty”). The
        length of this Warranty is based on the product and or product category
        listed below. This limited Warranty only extends to those customers who
        buy direct from Sicunet Inc. or through Sicunet Inc’s authorized
        distribution channels. Warranty coverage time frame is determined by
        product date code or if product is serialized by the date the product is
        shipped to the customer from our distribution centers. 
      </p>
      <p className="text-[13px] font-semibold text-[#121212]  mb-3 md:mb-4 lg:mb-5">
        NOTE THAT ALL SICUNET PRODUCTS ARE DESIGNED TO BE INSTALLED AND SERVICED
        BY TRAINED PROFESSIONALS. 
      </p>
      <p className="text-[#4A4C56] text-[13px] font-medium text-justify  mb-3 md:mb-4 lg:mb-5">
        The user is responsible for all labor costs associated with removing,
        reinstalling and returning the product Sicunet. Sicunet, at its option,
        will repair or replace the defective product. 
      </p>
      <p className="text-[#4A4C56] text-[13px] font-medium text-justify  mb-3 md:mb-4 lg:mb-5">
        Replacements may be made from b-stock products. If an exact replacement
        is not available, Sicunet, at its option, will select the nearest
        equivalent product. Sicunet will return warranted repaired or
        replacements by UPS Ground or an equivalent service. 
      </p>
      <p className="text-[#4A4C56] text-[13px] font-medium text-justify  mb-3 md:mb-4 lg:mb-5">
        A customer may pay the additional costs for second day or next-day
        service. All goods requiring warranty coverage shall be sent freight
        prepaid to a Sicunet designated location. Sicunet assumes no risk and
        shall be subject to no liability for damages or loss resulting from the
        specific use or application made of the Products.
      </p>
      <p className="text-[#4A4C56] text-[13px] font-medium text-justify  mb-3 md:mb-4 lg:mb-5">
         Sicunet Inc.’s liability for any claim, whether based on breach of
        contract, negligence, infringement of any rights of any party or product
        liability, relating to the Products shall not exceed the price paid by
        the Dealer to Sicunet for such Products. In no event will Sicunet be
        liable for labor cost or other reimbursements for any special,
        incidental or on sequential damages (including loss of use, loss of
        profit and claims of third parties) however caused, whether by the
        negligence of Sicunet or otherwise of any kind. 
      </p>
      <p className="text-[#4A4C56] text-[13px] font-medium text-justify  mb-3 md:mb-4 lg:mb-5">
        The above warranty provides the Dealer with specific legal rights. The
        Dealer may also have additional rights, which are subject to variation
        from state to state. Dealer Name Contact phone number and email Model
        and serial number or MAC address Date Code Details of the defect or
        problem If there is a dispute regarding the warranty of a product which
        does not fall under the warranty conditions stated above, please include
        a written explanation with the product when returned. Method of return
        shipment shall be the same or equal to the method by which the item was
        received by Sicunet. 
      </p>
      <p className="text-[#4A4C56] text-[13px] font-medium text-justify  mb-3 md:mb-4 lg:mb-5">
        The duration of Sicunet Inc.’s Warranty is set forth below: 
      </p>
      <p className="text-[22px] font-semibold text-[#121212]  mb-3 md:mb-4 lg:mb-5">
        Neptune 2.0 Product Line – 5 Years All returns are to be sent back to: 
      </p>
      <p className="text-[#4A4C56] text-[13px] font-medium text-justify  mb-3 md:mb-4 lg:mb-5">
        RMA# Sicunet Inc. <br />
        129A Morgan Drive, Norwood, MA 02062 <br />
        Massachusetts, USA <br />
        {/* Tel: <span className="whitespace-nowrap">857-346-0130</span> */}
      </p>

      <p className="text-[22px] font-semibold text-[#121212]  mb-3 md:mb-4 lg:mb-5">
        Please be sure the product is packaged appropriately so that is not
        damaged in shipping upon return.
      </p>
      <p className="text-[#4A4C56] text-[13px] font-medium text-justify  mb-3 md:mb-4 lg:mb-5">
        If a warranty repair is required, the Dealer must contact Sicunet
        technical support at 857-346-0130 
      </p>
      <p className="text-[#4A4C56] text-[13px] font-medium text-justify  mb-3 md:mb-4 lg:mb-5">
        Ext: 2 to obtain a Return Material Authorization number (RMA). In order
        to obtain an RMA number, the caller will be asked to provide the
        following information:
      </p>
      <div className="text-[#4A4C56] text-[13px] font-medium text-justify  mb-3 md:mb-4 lg:mb-5 ml-[30px] space-y-2">
        <div className="flex items-start gap-2">
          <span className="w-1.5 h-1.5 mt-2 rounded-full bg-[#4A4C56] flex-shrink-0"></span>
          <p>Dealer Name</p>
        </div>
        <div className="flex items-start gap-2">
          <span className="w-1.5 h-1.5 mt-2 rounded-full bg-[#4A4C56] flex-shrink-0"></span>
          <p>Contact phone number and email</p>
        </div>
        <div className="flex items-start gap-2">
          <span className="w-1.5 h-1.5 mt-2 rounded-full bg-[#4A4C56] flex-shrink-0"></span>
          <p>Date Code</p>
        </div>
        <div className="flex items-start gap-2">
          <span className="w-1.5 h-1.5 mt-2 rounded-full bg-[#4A4C56] flex-shrink-0"></span>
          <p>Details of the defect or problem</p>
        </div>
      </div>

      <p className="text-[#4A4C56] text-[13px] font-medium text-justify  mb-3 md:mb-4 lg:mb-5">
        If there is a dispute regarding the warranty of a product which does not
        fall under the warranty conditions stated above, please include a
        written explanation with the product when returned. Method of return
        shipment shall be the same or equal to the method by which the item was
        received by Sicunet. The duration of Sicunet Inc.’s Warranty is set
        forth below:
      </p>
      <p className="text-[13px] font-semibold text-[#121212]">
        Neptune 2.0 Product Line – 5 Years <br />
        All returns are to be sent back to: <br />
        RMA# <br />
        Sicunet Inc. <br />
        129A Morgan Drive, Norwood, MA 02062 <br />
        Massachusetts, USA <br />
        {/* Tel: <span className="whitespace-nowrap">857-346-0130</span> */}
      </p>

      <p className="text-[#4A4C56] text-[13px] font-medium text-justify  mb-3 md:mb-4 lg:mb-5">
        Please be sure the product is packaged appropriately so that is not
        damaged in shipping upon return.
      </p>
      <p className="text-[13px] font-semibold text-[#4A4C56]  mb-3 md:mb-4 lg:mb-5">
        Please download RMA Form.
      </p>
      <p className="text-[22px] font-bold text-[#121212]  mb-3 md:mb-4 lg:mb-5">
        Warranty Exceptions
      </p>
      <p className="text-[13px] font-semibold text-[#121212]  mb-3 md:mb-4 lg:mb-5">
        1. The warranties do not apply to:
      </p>
      <div className="text-[#4A4C56] text-[13px] font-medium text-justify  mb-3 md:mb-4 lg:mb-5 ml-[30px] space-y-2">
        <div className="flex items-start gap-2">
          <span className="w-1.5 h-1.5 mt-1 rounded-full bg-[#4A4C56] flex-shrink-0"></span>
          <p>Damage incurred in shipping or handling;</p>
        </div>
        <div className="flex items-start gap-2">
          <span className="w-1.5 h-1.5 mt-1 rounded-full bg-[#4A4C56] flex-shrink-0"></span>
          <p>
            Damage caused by disaster such as fire, flood, wind, earthquake or
            lightning;
          </p>
        </div>
        <div className="flex items-start gap-2">
          <span className="w-1.5 h-1.5 mt-1 rounded-full bg-[#4A4C56] flex-shrink-0"></span>
          <p>
            Damage due to causes beyond the control of Sicunet Inc. such as
            excessive voltage, mechanical shock or water damage;
          </p>
        </div>
        <div className="flex items-start gap-2">
          <span className="w-1.5 h-1.5 mt-1 rounded-full bg-[#4A4C56] flex-shrink-0"></span>
          <p>
            Damage caused by unauthorized attachment, alterations, modifications
            or foreign objects being used with or in conjunction with the
            product;
          </p>
        </div>
        <div className="flex items-start gap-2">
          <span className="w-1.5 h-1.5 mt-1 rounded-full bg-[#4A4C56] flex-shrink-0"></span>
          <p>
            Damage caused by peripherals, sensors or other products used in
            connection with the products;
          </p>
        </div>
        <div className="flex items-start gap-2">
          <span className="w-1.5 h-1.5 mt-1 rounded-full bg-[#4A4C56] flex-shrink-0"></span>
          <p>
            Defects caused by failure to provide a suitable installation
            environment for the products;
          </p>
        </div>
        <div className="flex items-start gap-2">
          <span className="w-1.5 h-1.5 mt-1 rounded-full bg-[#4A4C56] flex-shrink-0"></span>
          <p>
            Damage caused by use of the products for purposes other than those
            for which they were designed;
          </p>
        </div>
        <div className="flex items-start gap-2">
          <span className="w-1.5 h-1.5 mt-1 rounded-full bg-[#4A4C56] flex-shrink-0"></span>
          <p>Damage from improper maintenance or installation;</p>
        </div>
        <div className="flex items-start gap-2">
          <span className="w-1.5 h-1.5 mt-1 rounded-full bg-[#4A4C56] flex-shrink-0"></span>
          <p>
            Damage arising out of any other abuse, mishandling or improper
            application of the products;
          </p>
        </div>
        <div className="flex items-start gap-2">
          <span className="w-1.5 h-1.5 mt-1 rounded-full bg-[#4A4C56] flex-shrink-0"></span>
          <p>
            Damage resulting from disassembly or repair in such a manner as to
            adversely affect performance or prevent adequate inspection or
            testing to verify any warranty claim;
          </p>
        </div>
        <div className="flex items-start gap-2">
          <span className="w-1.5 h-1.5 mt-1 rounded-full bg-[#4A4C56] flex-shrink-0"></span>
          <p>Returns based on product revision level or software version.</p>
        </div>
      </div>

      <p className="text-[#4A4C56] text-[13px] font-medium text-justify  mb-3 md:mb-4 lg:mb-5">
        2. Product warranties set forth herein are void if the product has been
        tampered with, including but not limited to the date code, labels or
        other markings on the product.
      </p>
      <p className="text-[#4A4C56] text-[13px] font-medium text-justify  mb-3 md:mb-4 lg:mb-5">
        3. Products that are damaged in transit to Sicunet Inc. will not be
        covered under these warranties. If products are damaged or lost by the
        carrier, it is the sender’s risk and responsibility to create a claim
        against the carrier if they chose to do so.
      </p>
      <p className="text-[#4A4C56] text-[13px] font-medium text-justify  mb-3 md:mb-4 lg:mb-5">
        Overstock Inventory All product returned to Sicunet Inc. as overstock
        must have an RMA#., please call ask to talk to your Customer Service
        Representative.
      </p>
      <p className="text-[#4A4C56] text-[13px] font-medium text-justify  mb-3 md:mb-4 lg:mb-5">
        The following information must first be made available:
      </p>
      <ol className="text-[#4A4C56] text-[13px] font-medium text-justify  mb-3 md:mb-4 lg:mb-5">
        <p>1. Customer Name.</p>
        <p>2. Shipping Address.</p>
        <p>3. Telephone Number.</p>
        <p>4. Contact Name.</p>
        <p>5. The Part Number(s) being returned.</p>
        <p>6. The Quantity of each item being returned.</p>
        <p>7. The Product’s Date Code.</p>
      </ol>
      <p className="text-[13px] font-semibold text-[#121212]  mb-3 md:mb-4 lg:mb-5">
        The following terms apply to overstock product returns for exchange:
      </p>
      <p className="text-[#4A4C56] text-[13px] font-medium text-justify  mb-3 md:mb-4 lg:mb-5">
        <p>
          1. All overstock returns will be required to provide a minimum
          offsetting PO / order equal to equipment value to be returned. Sicunet
          Inc. will not provide a monetary refund in anything other than Sicunet
          Inc. products.
        </p>
        <p>
          2. There may be a 25% restocking fee on all accepted products for
          overstock. A PO must be attached to the RMA# authorizing this
          restocking fee. The restocking fee will be waived if a new PO for a
          minimum of 150% of the value of the returned product is received with
          the RMA request.
        </p>
        <p>
          3. The cost of shipping to Sicunet Inc. is the responsibility of the
          sender.
        </p>
        <p>
          4. Product that has been used cannot be returned for credit. Return of
          used product must follow the regular RMA procedures.
        </p>
        <p>
          5. RMA’s are valid for 30 days, after which time the RMA# is canceled
          and will not be accepted. The product will be returned at the sender’s
          expense. A new RA# must be obtained before the product can be
          returned.
        </p>
        <p>
          6. All returned products must be in new resalable condition and have
          its original packaging intact.
        </p>
        <p>
          7. Products to be returned must be a current sellable part and deemed
          to be viable inventory.
        </p>
      </p>
      <p className="text-[13px] font-semibold text-[#121212]  mb-3 md:mb-4 lg:mb-5">
        Advanced Replacements
      </p>
      <p className="text-[#4A4C56] text-[13px] font-medium text-justify  mb-3 md:mb-4 lg:mb-5">
        Sicunet Inc. does not issue advance replacements for defective
        equipment. Dealers and distributors are expected to carry stock in order
        to service their customers for replacement purposes. (See RMA Policy for
        repair procedures). If the requestor has an established credit line,
        Sicunet may consider sending Advance Replacements for equipment on an
        emergency basis and subject to the following. If it is determined by
        Technical Support that a product is defective, in warranty, and in
        immediate need of replacement may at its discretion issue a return
        material authorization and enter a Sales Order to accommodate the
        request for replacement product. The customer will be charged for the
        replacement product. Sicunet Inc. will pay for normal shipping charges,
        any expedited shipping (i.e. FedEx, UPS Red, UPS Blue, etc.) will be
        paid by the customer.
      </p>
      <p className="text-[13px] font-semibold text-[#121212]  mb-3 md:mb-4 lg:mb-5">
        The following exceptions apply to requests for Advance Replacements:
      </p>
      <ol className="text-[#4A4C56] text-[13px] font-medium text-justify  mb-3 md:mb-4 lg:mb-5">
        <p>
          1. A Sales Order and Invoice will be generated authorizing the advance
          replacement. The customer will be charged for the replacement product.
        </p>
        <p>
          2. The customer must provide a with a Purchase Order at the time that
          the replacement product request is made. This Purchase Order is
          required to cover the cost of the product and any expedited shipping
          costs.
        </p>
        <p>
          3. The customer has 30 days to return the product in order to receive
          the offsetting credit to their account. If the product is not received
          within 30 days, no credit will be issued and the payment for the
          replacement product will be due immediately.
        </p>
        <p>
          4. If the product returned does not meet the warranty requirements for
          normal wear and use, the product will be returned at the sender’s
          expense. No credit will be issued and payment for the replacement
          product will be due immediately.
        </p>
        <p>
          5. Returned equipment should be a package in the same packaging as the
          replacement product to avoid additional damage in shipment.
        </p>
        <p>
          6. The RMA# must be clearly indicated on the outside of the shipping
          carton. Product that is returned without the proper labeling will be
          returned at the sender’s expense.
        </p>
        <p>
          7. The cost of shipping to Sicunet is the responsibility of the
          sender. An offsetting credit will be processed within 30 days of
          receipt of the product.
        </p>
        <p>
          8. All other criteria for RMA’s will apply as stated in the above
          policies.
        </p>
      </ol>
    </div>
  );
};

export default WarrantyInfo;
